import { render } from "./OrderListView.vue?vue&type=template&id=20ef2720"
import script from "./OrderListView.vue?vue&type=script&lang=js"
export * from "./OrderListView.vue?vue&type=script&lang=js"

import "./OrderListView.vue?vue&type=style&index=0&id=20ef2720&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__